module.exports = __webpack_public_path__ + "img/ticket-pass.100b1b3e.svg";